import * as React from 'react'

import { i18n, useSiteConfig } from '@thg-commerce/enterprise-core'
import { FrequentlyBoughtTogetherData } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Query/Product/FrequentlyBoughtTogether'

import { useProductPage } from '../../context'

import {
  FrequentlyBoughtTogether,
  FrequentlyBoughtTogetherProps,
} from './FrequentlyBoughtTogether'

export type FrequentlyBoughtTogetherResult = {
  frequentlyBoughtTogether: FrequentlyBoughtTogetherData['product']
}

export const FrequentlyBoughtTogetherRenderer = () => {
  const {
    displayFrequentlyBoughtRecommendations,
    showOutOfStockAsDisabledOnFrequentlyBoughtTogether,
    enableFBTProductOptionPlacement,
    enableFBTHalfPageStyling,
  } = useSiteConfig()
  const { product } = useProductPage()

  const i18nText = {
    frequentlyBoughtTogether: i18n('product.frequentlyboughttogether.title'),
    thisItem: i18n('product.frequentlyboughttogether.thisitem'),
    recommendedItem: i18n('product.frequentlyboughttogether.recommendeditem'),
    addBothToBasket: i18n('product.frequentlyboughttogether.addbothtobasket'),
    from: i18n('product.frequentlyboughttogether.from.text'),
    totalPrice: i18n('product.frequentlyboughttogether.totalprice.text'),
  }

  if (
    !product ||
    !displayFrequentlyBoughtRecommendations ||
    !product.frequentlyBoughtTogether ||
    Object.keys(product.frequentlyBoughtTogether).length === 0
  ) {
    return null
  }

  const props: FrequentlyBoughtTogetherProps = {
    i18nText,
    showOutOfStockAsDisabledOnFrequentlyBoughtTogether,
    enableFBTProductOptionPlacement,
    enableFBTHalfPageStyling,
    ...product.frequentlyBoughtTogether,
  }

  return <FrequentlyBoughtTogether {...props} />
}
